module.exports = __webpack_public_path__ + "static/media/frc-summer-2022-top-asset.2f84f483.png";